import ProductsLogApi, {SkuData} from "../../api/ProductsLogApi"
import {action, makeAutoObservable} from "mobx"

export default class Sku implements SkuData {
    readonly category_id!: number
    readonly category_name!: string
    readonly id!: number
    readonly name!: string
    readonly product_id!: number
    readonly product_name!: string
    readonly url!: string

    constructor(data: SkuData) {
        Object.assign(this, data)
        makeAutoObservable(this)
    }

    private _stock_update_answer: object | undefined

    get stock_update_answer(): object | undefined {
        return this._stock_update_answer
    }

    private _update_price_answer: object | undefined

    get update_price_answer(): object | undefined {
        return this._update_price_answer
    }

    set update_price_answer(value: object | undefined) {
        this._update_price_answer = value
    }

    private _export_product_answer: object | undefined

    get export_product_answer(): object | undefined {
        return this._export_product_answer
    }

    private _stock_update_data: object | undefined

    get stock_update_data(): object | undefined {
        return this._stock_update_data
    }

    private _price_update_data: object | undefined

    get price_update_data(): object | undefined {
        return this._price_update_data
    }

    private _is_loading = false
    get is_loading() {
        return this._is_loading
    }

    private _data_to_export: object | undefined
    get data_to_export(): object | undefined {
        return this._data_to_export
    }

    private _is_open: boolean = false

    get is_open(): boolean {
        return this._is_open
    }

    set is_open(value: boolean) {
        this._is_open = value
        if (value) {
            this.getData()
        }
    }

    getData() {
        this._is_loading = true
        ProductsLogApi.getProduct(this.product_id, this.id).then(action("productLoaded", (result) => {
            const data = result.data.data
            this._data_to_export = data.to_export
            this._price_update_data = data.prices
            this._stock_update_data = data.stocks
            if (data.logs) {
                const logs = data.logs
                if (logs.stock_answer) {
                    this._stock_update_answer = JSON.parse(logs.stock_answer)
                }
                if (logs.update_price_answer) {
                    this._update_price_answer = JSON.parse(logs.update_price_answer)
                }
                if (logs.export_product_answer) {
                    this._export_product_answer = JSON.parse(logs.export_product_answer)
                }

            }
            this._is_loading = false
        }))
    }
}